import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {SessionManager} from "../../session-manager";

export class PrivateRoute extends React.Component {

    render() {
        return SessionManager.isAuthenticated() ? <Route {...this.props} /> :
            <Redirect to={{pathname: "/login", state: {from: this.props.location}}}/>
    }
}